var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.83955 6.76419C2.65792 8.15354 2.54759 9.56532 2.51235 10.9957C4.44301 11.8018 6.27929 12.7888 8 13.9355C9.72071 12.7888 11.557 11.8018 13.4876 10.9957C13.4524 9.56533 13.3421 8.15356 13.1605 6.76421M2.83955 6.76419C2.25575 6.56796 1.66486 6.38714 1.06738 6.22222C3.23097 4.70567 5.55161 3.39789 8.00003 2.32812C10.4485 3.39789 12.7691 4.70567 14.9327 6.22223C14.3352 6.38715 13.7443 6.56797 13.1605 6.76421M2.83955 6.76419C4.63104 7.36635 6.35586 8.11368 8.00003 8.99218C9.64418 8.11369 11.369 7.36637 13.1605 6.76421M4.5 9.99976C4.77614 9.99976 5 9.7759 5 9.49976C5 9.22361 4.77614 8.99976 4.5 8.99976C4.22386 8.99976 4 9.22361 4 9.49976C4 9.7759 4.22386 9.99976 4.5 9.99976ZM4.5 9.99976V7.5494C5.62765 6.84875 6.79575 6.20705 8 5.62862M3.32843 13.3282C4.10947 12.5471 4.5 11.5234 4.5 10.4998V9.49976",
    stroke: "#5F606D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicCap);
export default __webpack_public_path__ + "static/media/academic-cap.19eceaaae928663baafccfd8428f25c6.svg";
export { ForwardRef as ReactComponent };